import { Image } from 'react-native';
export const getImageSize = (uri) => {
    let cancel;
    const start = () => new Promise((resolve, reject) => {
        cancel = reject;
        Image.getSize(uri, (width, height) => {
            cancel = undefined;
            resolve({ width, height });
        }, error => {
            reject(error);
        });
    });
    return { start, cancel };
};
//# sourceMappingURL=getImageSize.js.map